"use client";
import { useState, useEffect } from "react";
import { usePathname, useRouter } from "next/navigation";
import Cookies from "js-cookie";
import useClientRouter from "@/hooks/useClientRouter";

const Lang = () => {
  const { params } = useClientRouter();

  const pathname = usePathname();
  const router = useRouter();
  const [language, setLanguage] = useState("");

  const ChangeLang = (lang) => {
    Cookies.set("NEXT_LOCALE", lang);
    const segments = pathname.split("/");

    const supportedLocales = ["az", "en", "ru"];
    if (segments.length > 1 && supportedLocales.includes(segments[1])) {
      segments[1] = lang;
    } else {
      segments.splice(1, 0, lang);
    }

    const newPath = (segments.join("/") || "/").concat(
      params.toString() ? "?" + params.toString() : ""
    );

    router.push(newPath);

    setTimeout(() => {
      router.refresh();
    }, 100);
  };

  useEffect(() => {
    const current = Cookies.get("NEXT_LOCALE") || "az";
    setLanguage(current);
  }, [pathname]);

  if (!language) return null;

  return (
    <div className="lang">
      {language !== "az" && (
        <button type="button" onClick={() => ChangeLang("az")}>
          AZ
        </button>
      )}
      {language !== "en" && (
        <button type="button" onClick={() => ChangeLang("en")}>
          EN
        </button>
      )}
      {language !== "ru" && (
        <button type="button" onClick={() => ChangeLang("ru")}>
          RU
        </button>
      )}
    </div>
  );
};

export default Lang;
